import React, { useEffect } from "react";
import { useBotStore } from "../../stores/botStore";
import { PaginationControls } from "components";

// Компонент відображення таблиці "Архів скасувань"
const CancellationArchiveTable = ({ getManagerName, getStatusBadge, formatDate }) => {
  // Отримуємо дані архіву зі стору
  const archive = useBotStore((state) => state.archive);
  const archivePagination = useBotStore((state) => state.archivePagination);
  const fetchArchive = useBotStore((state) => state.fetchArchive);
  const isLoading = useBotStore((state) => state.isLoading);

  // Ефект для завантаження архіву при першому завантаженні сторінки
  useEffect(() => {
    fetchArchive(1);
  }, [fetchArchive]);

  // Допоміжна функція для відображення елементів архіву
  const renderArchiveItem = (item) => {
    const desc =
      typeof item.description === "string"
        ? JSON.parse(item.description)
        : item.description;

    const typeNames = {
      clean: "Видалив(ла) зі статистики",
      change: "Змінив(ла) менеджера",
    };

    return (
      <div key={item.id} className="archive-log-item">
        <div className="archive-log-header">
          <span className="archive-log-user">
            {item.username || item.user_id || "Невідомий"}
          </span>
          <span className="archive-log-action">
            {typeNames[item.type] || item.type}
          </span>
          <strong className="archive-log-id">#{desc?.order_id || "?"}</strong>
          {getStatusBadge(item.status)}
        </div>

        {desc?.manager_id && (
          <div className="archive-log-details">
            Менеджер:{" "}
            <span className={item.type === "change" ? "strike-through" : ""}>
              {getManagerName(desc.manager_id)}
            </span>
            {item.type === "change" && desc?.new_manager_id && (
              <>
                {" → "}
                <span className="highlight-new">
                  {getManagerName(desc.new_manager_id)}
                </span>
              </>
            )}
          </div>
        )}

        <div className="archive-log-time">
          {item.processed_at
            ? `Оброблено: ${formatDate(item.processed_at)}`
            : formatDate(item.created_at)}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="table-title">
        <h3>Архів операцій</h3>
      </div>

      <div className="botsettings-table">
        {isLoading ? (
          <div className="loading-placeholder">Завантаження...</div>
        ) : archive.length === 0 ? (
          <div className="archive-empty">Немає записів в архіві</div>
        ) : (
          <div className="archive-list">{archive.map(renderArchiveItem)}</div>
        )}
      </div>

      {!isLoading && archive.length > 0 && (
        <div style={{ marginTop: "0.75rem" }}>
          <PaginationControls
            page={archivePagination.page}
            totalPages={archivePagination.totalPages}
            onPageChange={(page) => fetchArchive(page)}
            maxVisible={3}
          />
        </div>
      )}
    </>
  );
};

export default CancellationArchiveTable;
